import state from './state'
import * as mutations from './mutations'
import * as actions from './actions'
import * as xcalacocoBookingsActions from './xcalacocoBookingsActions'
import * as beachClubBookingsActions from './beachClubBookingsActions'
import * as getters from './getters'

export default {
    namespaced: true,
    state,
    mutations,
    actions: { ...actions, ...xcalacocoBookingsActions, ...beachClubBookingsActions },
    getters 
}